export class MultiStorage {
    // TODO: Implement
    // TODO: How about Object and Async storages and IObservableStorage
}
